var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseWithBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#E9E9E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6273 15.3941C14.8335 15.6002 15.1754 15.6002 15.3816 15.3941C15.5877 15.1879 15.5877 14.846 15.3816 14.6398L12.7417 12L15.3816 9.36016C15.5877 9.154 15.5877 8.81207 15.3816 8.60591C15.1754 8.39975 14.8335 8.39975 14.6273 8.60591L11.9875 11.2458L9.3476 8.60586C9.14144 8.3997 8.79952 8.3997 8.59336 8.60586C8.3872 8.81202 8.3872 9.15395 8.59336 9.36011L11.2332 12L8.59336 14.6399C8.3872 14.8461 8.3872 15.188 8.59336 15.3941C8.79952 15.6003 9.14144 15.6003 9.3476 15.3941L11.9875 12.7542L14.6273 15.3941Z",
    fill: "#5A5C61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWithBg);
export default __webpack_public_path__ + "static/media/closeWithBG.a949cb0b6da7b1b4d0126f4f0fddf68f.svg";
export { ForwardRef as ReactComponent };